'use strict';

angular.module('mean.projects').controller('WorkOrderController', ['$scope', '$state', '$location', 'MeanUser', 'Global', '$filter', '$q', 'toaster', 'Bids', 'ngDialog', 'taskTotalsService', 'tradeCodeService', 'foremanPhaseService', 'userService', 'projectWorkOrderPrintService', 'ProjectTasks', 'ProjectHours', 'ProjectMaterials', 'ProjectEquipments', 'Options', 'ProjectBids', 'TradeBids',
  function($scope, $state, $location, MeanUser, Global, $filter, $q, toaster,  Bids, ngDialog, taskTotalsService, tradeCodeService, foremanPhaseService, userService, projectWorkOrderPrintService, ProjectTasks, ProjectHours, ProjectMaterials, ProjectEquipments, Options, ProjectBids, TradeBids) {
    $scope.global = Global;

    $scope.available_lots = [];
    $scope.lotSelection = [];
    $scope.lot_has_one = false;
    $scope.has_many = false;
    $scope.available_tasks = [];
    $scope.taskSelection = [];
    $scope.task_has_one = false;
    $scope.task_has_many = false;

    console.log('WorkOrderController');

    if($state.params.project == null || 
        $state.params.builder == null || 
        $state.params.my_trade == null ||
        $state.params.print_options == null) {
        $location.path('/project/admin');
        return;
    }

    $scope.project = $state.params.project;
    $scope.builder = $state.params.builder;
    $scope.my_trade = $state.params.my_trade;
    $scope.print_options = $state.params.print_options;

    $scope.work_order_options = $scope.print_options.work_order_options;

    $scope.moveUp = function(item, $index) {
        console.log(item);
        if(item.label == 'Page Break') {
            $scope.work_order_options.show_page_break = true;
        }
        var temp = $scope.work_order_options.order[$index-1];
        $scope.work_order_options.order[$index-1] = item;
        $scope.work_order_options.order[$index] = temp;
    };

    $scope.moveDown = function(item, $index) {
        console.log(item);
        if(item.label == 'Page Break' && $index+1 == item.value) {
            $scope.work_order_options.show_page_break = false;
        }
        var temp = $scope.work_order_options.order[$index+1];
        $scope.work_order_options.order[$index+1] = item;
        $scope.work_order_options.order[$index] = temp;
    };

    $scope.updatePrintOptions = function() {
        $scope.print_options.$update(function(success) {
            toaster.pop('success', 'Print Options Updated');
            $scope.print_options = success;
            $scope.work_order_options = success.work_order_options;
        }, function(error) {
            toaster.pop('error', 'Error Updating Print Options', error);
        })
    };

    $scope.example15settings = {
        buttonClasses: 'form-control',
        externalIdProp: '',
        scrollable: true,
        scrollableHeight: '140px',
        enableSearch: false,
        smartButtonMaxItems: 1,
        smartButtonTextConverter: function (itemText, originalItem) {
            if ($scope.lotSelection.length > 1) {
                return $scope.lotSelection.length + ' checked'
            } else {
                return itemText;
            }
        }
    };

    $scope.example5customTexts = {
        buttonDefaultText: 'Select Lots'
    };

    $scope.selectionEvents = function () {
        if (this.lotSelection.length === 0) {
            if (this.lot_has_one) {
                this.lot_has_one = false;
                this.has_many = false;
                this.selectedLot = {};
            }
            return;
        }

        if (this.lotSelection.length === 1) {
            // this.has_many = false;
            // var lot = $filter('filter')(this.selectedPhase.lot, {
            //     'name': this.lotSelection[0].label
            // }, true);

            // if (lot.length === 1)
            //     this.selectedLot = lot[0];
            // else
            //     this.selectedLot = {};
        } else {
            this.lot_has_one = false;
            this.has_many = true;
            return;
        }

        this.lot_has_one = true;
    };

    $scope.taskSettings = {
        buttonClasses: 'form-control',
        externalIdProp: '',
        scrollable: true,
        scrollableHeight: '140px',
        enableSearch: false,
        smartButtonMaxItems: 1,
        smartButtonTextConverter: function (itemText, originalItem) {
            if ($scope.taskSelection.length > 1) {
                return $scope.taskSelection.length + ' checked'
            } else {
                return itemText;
            }
        }
    };

    $scope.taskCustomTexts = {
        buttonDefaultText: 'Select Tasks'
    };

    $scope.taskSelectionEvents = function () {
        if (this.taskSelection.length === 0) {
            if (this.task_has_one) {
                this.task_has_one = false;
                this.task_has_many = false;
                this.selectedTask = {};
            }
            return;
        }

        if (this.selectedTask.length === 1) {
            // this.task_has_many = false;
            // var lot = $filter('filter')(this.selectedPhase.lot, {
            //     'name': this.selectedTask[0].label
            // }, true);

            // if (lot.length === 1)
            //     this.selectedTask = lot[0];
            // else
            //     this.selectedTask = {};
        } else {
            this.task_has_one = false;
            this.task_has_many = true;
            return;
        }

        this.task_has_one = true;
    };

    var tasks = $filter('filter')($scope.project.plan[0].task_list, {
        'trade': userService.getTradeCode(MeanUser.user.username)}, true);

    for (var i = 0; i < tasks.length; i++) {
        $scope.available_tasks.push({
            id: i,
            label: tasks[i].name,
            task_code : tasks[i].trade + tasks[i].task
        });
    }

    for (var i = 0; i < $scope.project.lots.length; i++) {
        $scope.available_lots.push({
            id: i,
            label: $scope.project.lots[i].phase + '-' + $scope.project.lots[i].number
        });
    }

    $scope.closeWorkOrder = function() {
        $location.path('/project/admin', {selectedBuilder: $scope.builder, selectedItem: $scope.project});
    };

    $scope.printWorkOrder = function() {
        if(this.lotSelection.length != 1) {
            toaster.pop('error', 'Lot Selection Error', 
                'Please select only one lot to generate a work order');
            return;
        }

        var lot_array = this.lotSelection[0].label.split('-');
        var project_lot = $filter('filter')($scope.project.lots, {
            'phase': lot_array[0], 'number': lot_array[1]}, true)[0];

        var data = {
            project: $scope.project,
            builder: $scope.builder,
            my_trade: $scope.my_trade,
            user: MeanUser.user,
            lot_selection: {
                phase: lot_array[0],
                lot: lot_array[1]
            },
            task_selection: this.taskSelection,
            notes: this.work_order_options.notes
        }

        ProjectBids.query({'project_id': data.project._id, 
            'trade': data.user.trade[0],
            'plan_code':  project_lot.plan }, function (project_bids) {
            data.project_bids = project_bids;
            ProjectTasks.query({'project_id': data.project._id, 
                'trade': data.user.trade[0] }, function (tasks) {
                //filter based on lot selection. can only be one lot
                var tasks = $filter('filter')(tasks, { 'phase': data.lot_selection.phase,
                    'lot': data.lot_selection.lot }, true);
                data.tasks = [];
                //reduce the number of tasks we deal with based on user selection
                _.each(data.task_selection, function(task) {
                    var select = $filter('filter')(tasks, {'task_code': task.task_code}, true)[0];

                    if(select)
                        data.tasks.push(select);
                });

                //build subtasks under respective tasks
                var materials = [];
                var equipment = [];
                _.each(data.tasks, function(task) {
                    //console.log(task);
                    //console.log(data.project_bids);
                    var bids = $filter('filter')(data.project_bids, {
                        'plan_code': task.plan_code,'task_code': task.task_code }, true);

                    //this happens if an option is applied to a lot
                    if(bids.length > 1) {
                        var check = $filter('filter')(bids, {'phase': data.lot_selection.phase,
                            'lot': data.lot_selection.lot }, true);

                        if(check.length == 1) {
                            bids = check;
                        } else if(check.length > 1) {
                            console.log('we got problems!!!!');
                        } else {
                            check = $filter('filter')(bids, {'revision': project_lot.revision}, true);

                            if(check.length == 0) {
                                check = $filter('filter')(bids, {'latest': true}, true);
                            }

                            if(check.length == 1) {
                                bids = check;
                            } else if(check.length > 1) {
                                console.log('we got some real problems!!!!');
                            }
                        }

                        if(bids.length == 1) {
                            task.subtasks = bids[0].subtasks;
                            if(bids[0].materials.length > 0)
                                angular.extend(materials, bids[0].materials);
                            if(bids[0].equipment.length > 0)
                                angular.extend(equipment, bids[0].equipment);
                        } else {
                            toaster.pop('error', 'Bid/Task Error', 
                                'Problem finding one bid for task ' + task.task_code);
                        }
                    } else if(bids.length == 1) {
                        task.subtasks = bids[0].subtasks;
                        if(bids[0].materials.length > 0)
                            angular.extend(materials, bids[0].materials);
                        if(bids[0].equipment.length > 0)
                            angular.extend(equipment, bids[0].equipment);
                    }

                    // task.quantity = 0;
                    // task.total = 0;
                    // _.each(task.subtasks, function(subtask) {
                    //     task.quantity += parseFloat(subtask.quantity);
                    //     task.total += parseFloat(subtask.total);
                    // })
                });

                data.materials = materials;
                data.equipment = equipment;

                _.each(data.materials, function(item) {
                    var color_scheme = $filter('filter')(item.color_scheme, {
                        'category': project_lot.plan }, true)[0];
                    item.color_scheme = (color_scheme)?color_scheme.option:'';
                    item.total = item.quantity * item.price_per_order +
                        item.delivery_price * item.quantity;
                })

                _.each(data.equipment, function(item) {
                    item.total = item.quantity * item.price_per_order;
                })

                ProjectHours.query({'project_id': data.project._id, 
                    'trade': data.user.trade[0] }, function(project_hours) {
                    var hours = [];
                    data.hours = [];
                    _.each(data.tasks, function(task) {
                        var temp = $filter('filter')(project_hours, {'project_task_id': task._id}, true);
                        hours = hours.concat(temp);
                    });
                    data.hours = hours;
                    // ProjectMaterials.query({'project_id': data.project._id,
                    //     'submitted': true,
                    //     'trade': data.user.trade[0] }, function(project_materials) {
                    //     data.material_reports = [];
                    //     _.each(project_materials, function(report) {
                    //         if(report.phase = data.lot_selection.phase) {
                    //             var inlist = $filter('filter')(report.lots, { 'item': data.lot_selection.lot }, true);
                    //             //only add reports that have the selected lot
                    //             if(inlist.length > 0) {
                    //                 var should_add = $filter('filter')(data.task_selection, {
                    //                     'task_code': report.task_code }, true)[0];
                    //                 //only add for the selected tasks
                    //                 if(should_add)
                    //                     data.material_reports.push(report)
                    //             }
                    //         }
                    //     });

                    //     data.material_reports = project_materials;
                    //     ProjectEquipments.query({'project_id': data.project._id,
                    //         'submitted': true,
                    //         'trade': data.user.trade[0] }, function(project_equipment) {
                    //         data.equipment_reports = project_equipment;
                            Options.query({
                                'project_id': data.project._id//,
                                /*'trade_code': userService.getTradeCode(MeanUser.user.username)*/}, function(project_options) {
                                //might need to filter out options that don't apply to my trade
                                //or work the query better
                                data.options = [];
                                _.each(project_options, function(project_option) {
                                    _.each(project_option.options, function(option) {
                                        var active = $filter('filter')(project_lot.active_options, {
                                            'name': option.name, 'number': option.number }, true);

                                        var qty = 0;
                                        var total = 0;
                                        if(active && active.length == 1) {
                                            var op_totals = $filter('filter')(active[0].totals, {
                                                'trade': data.user.trade[0]}, true);
                                            if(op_totals.length == 1) {
                                                qty = op_totals[0].multiple;
                                                total = op_totals[0].total;
                                            } else {
                                                toaster.pop('error', 'Not Handling Error', 
                                                    'Getting back more options for this lot than planned');
                                            } 
                                        } else if(active && active.length > 1){
                                            toaster.pop('error', 'Too Many Error', 
                                                'Getting back more options for this lot than planned');
                                        } 

                                        var direct_labor = 0;
                                        _.each(option.subtasks, function(subtask) {
                                            if(subtask.piece_rate > 0)
                                                direct_labor += subtask.crew_rate * subtask.piece_rate;
                                            else
                                                direct_labor += subtask.crew_rate * subtask.piece_per_hour_rate;
                                        })

                                        data.options.push({
                                            name: option.name,
                                            number: option.number,
                                            description: option.description,
                                            quantity: qty,
                                            total: total,
                                            direct_labor: direct_labor,
                                            hidden: false,
                                        });
                                    });
                                });

                                Bids.query({
                                    'type': 'BidIDByProjectID', 
                                    'project_id': data.project._id}, function(bids) {
                                    if(bids.length == 1) {
                                        TradeBids.query({
                                            'type': 'PlanNotes',
                                            'trade': data.user.trade[0],
                                            'bid_id': bids[0]._id}, function(trade_notes) {
                                            if(trade_notes.length == 1) {
                                                data.trade_notes = $filter('filter')(trade_notes[0].plans, {
                                                    'code': project_lot.plan}, true)[0];
                                            }

                                            projectWorkOrderPrintService.buildPDF(
                                                data, 
                                                $scope.work_order_options);
                                        });
                                    }
                                });
                            });
                    //     });
                    // });
                });
            });
        });
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/controllers/workOrder.js